import { useCurrency } from '@procureai/ui-mui';
import { useCallback } from 'react';

interface FormatTotalProps {
  expectedPricePerUnit: number | null;
  quantity: number;
}
export const useTotalLineItemFormat = () => {
  const { format } = useCurrency();

  const getTotal = useCallback(({ expectedPricePerUnit, quantity }: FormatTotalProps) => {
    return expectedPricePerUnit === null ? 0 : expectedPricePerUnit * quantity;
  }, []);

  return {
    formatTotal: useCallback((item: FormatTotalProps) => format(getTotal(item)), [format, getTotal]),
    getTotal,
  };
};
